import React from "react";
import { Star, Quote } from "lucide-react";
const Quotes = Quote;
import { REVIEWS } from "@/lib/data";

export default function Reviews() {
  return (
    <section data-testid="reviews-section" className="bg-mrn-green py-24 md:py-32 text-mrn-cream relative overflow-hidden">
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_20%_20%,#D97B42,transparent_40%),radial-gradient(circle_at_80%_80%,#C85A3D,transparent_40%)]" />
      <div className="relative max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-2xl">
          <p className="text-xs uppercase tracking-[0.3em] text-mrn-amber font-medium">Guest Notes</p>
          <h2 className="mt-4 headline-display text-4xl md:text-6xl">
            Kind words from <em className="font-light text-mrn-sand">past weekends.</em>
          </h2>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-5">
          {REVIEWS.map((r, i) => (
            <div
              key={r.name}
              data-testid={`review-${i}`}
              className="rounded-2xl bg-white/5 backdrop-blur-sm border border-white/10 p-7"
            >
              <Quotes size={26} strokeWidth={1.5} className="text-mrn-amber" />
              <p className="mt-5 font-display text-xl leading-relaxed italic text-mrn-cream">
                “{r.quote}”
              </p>
              <div className="mt-6 flex items-center justify-between">
                <div>
                  <div className="font-medium text-mrn-cream">{r.name}</div>
                  <div className="text-xs text-mrn-sand/70">{r.city}</div>
                </div>
                <div className="flex gap-0.5">
                  {Array.from({ length: r.stars }).map((_, j) => (
                    <Star key={j} size={14} fill="currentColor" className="text-mrn-amber" />
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
